import React from "react";

const boxStyle = {
  width: "56px",
  height: "56px",
  borderRadius: "8px",
  marginRight: "10px",
  flexShrink: 0,
};

// A Gang Leader's daily work photo in the Daily Logs list. It used to be a
// 36px image that could not be opened (AMS-70); it now links to the full
// photo in a new tab, and says when the Gang Leader attached none.
function DailyWorkLogPhoto({ photo }) {
  if (!photo) {
    return (
      <div
        className="d-flex align-items-center justify-content-center text-muted font-11 bg-label-secondary"
        style={boxStyle}
      >
        No photo
      </div>
    );
  }
  return (
    <a href={photo} target="_blank" rel="noopener noreferrer" title="Open full photo">
      <img src={photo} alt="Daily work" style={{ ...boxStyle, objectFit: "cover", display: "block" }} />
    </a>
  );
}

export default DailyWorkLogPhoto;
